/**
 * Automated Social Trend-Tag Compiler.
 * Maps the current pathname to a high-intent platform hashtag bundle aligned
 * with global + local Google Trends patterns. Appended to share payloads
 * (WhatsApp, X, clipboard) to amplify discovery across X/Twitter, Instagram,
 * TikTok, and Threads.
 */

const BASE_TAGS = ["#DrHint"];
const GLOBAL_TRENDS = ["#Trending", "#Viral"];

export function compileTrendTags(pathname: string): string[] {
  const tags = new Set<string>(BASE_TAGS);

  // Gold rates
  if (/(gold|karat|tola|22k|24k|city\/(pakistan|india))/i.test(pathname)) {
    ["#GoldRateToday", "#GoldPrice", "#Gold24K", "#Gold22K", "#SonayKaRate"].forEach((t) => tags.add(t));
  }

  // Utility bills (PK)
  if (/(bill|fesco|gepco|hesco|iesco|kelectric|lesco|mepco|pesco|qesco|sepco|sngpl|ssgc|ptcl)/i.test(pathname)) {
    ["#ElectricityBill", "#BijliBill", "#PakistanBill", "#CheckYourBill"].forEach((t) => tags.add(t));
  }

  // Country hubs
  if (/^\/pakistan/.test(pathname)) ["#Pakistan", "#PK"].forEach((t) => tags.add(t));
  if (/^\/india/.test(pathname)) ["#India", "#IN"].forEach((t) => tags.add(t));

  GLOBAL_TRENDS.forEach((t) => tags.add(t));
  return Array.from(tags);
}

export function trendTagsLine(pathname: string): string {
  return compileTrendTags(pathname).join(" ");
}